/**
 * conformite.js
 * -------------
 * Registre RGPD de l'établissement.
 *
 * Backend : core/conformite_views.py — permission IsAdminLevel, scope
 * "fail-closed" par établissement.
 *
 * L'API ne renvoie AUCUN score de conformité, contrairement au design : un
 * pourcentage de conformité RGPD est une affirmation juridique, pas un ratio de
 * cases cochées. Seuls des comptes vérifiables sont exposés.
 */
import axiosClient from "../axiosClient";

/** GET /directeur/conformite/politiques/
 *  -> { politiques, manquantes, dpo, stats } */
export async function getRegistreRgpd() {
  const { data } = await axiosClient.get("/directeur/conformite/politiques/");
  return data || {};
}

/** POST /directeur/conformite/politiques/maj/ — crée ou met à jour une
 *  obligation. Toute écriture horodate la vérification côté serveur. */
export async function majPolitiqueRgpd(payload) {
  const { data } = await axiosClient.post("/directeur/conformite/politiques/maj/", payload);
  return data;
}
